import React, { useState, useEffect, useContext } from 'react';
import { Button, FormGroup, Label, Input, Alert } from 'reactstrap';
import { AppContext } from '../AppContext';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Card, CardHeader, CardBody, Row, Col } from 'reactstrap';
import { FaFileExcel } from 'react-icons/fa';
import withRoleAccess from './withRoleAccess';

const MySwal = withReactContent(Swal);
const APIURL = process.env.REACT_APP_API_URL;

const ReportesTecnologias = () => {

    const [yearTecnologia, setYearTecnologia] = useState('');
    const [termTecnologia, setTermTecnologia] = useState('');
    const [cicloTecnologia, setCicloTecnologia] = useState('');
    const [yearsTecnologia, setYearsTecnologia] = useState([]);
    const [ciclosTecnologia, setCiclosTecnologia] = useState([]);

    const [selectedTutorTecnologia, setSelectedTutorTecnologia] = useState('');
    const [tutoresTecnologia, setTutoresTecnologia] = useState([]);
    const [loadingTutores, setLoadingTutores] = useState(false);

    const [pdfData, setPdfData] = useState(null);
    const [pdfLoadingError, setPdfLoadingError] = useState(null);

    const currentUser = useContext(AppContext).currentUser;

    useEffect(() => {
        if (!currentUser) return;

        const fetchYears = async () => {
            try {
                MySwal.fire({
                    title: 'Cargando...',
                    text: 'Espere un momento',
                    allowOutsideClick: false,
                    didOpen: () => {
                        MySwal.showLoading();
                    }
                });

                const response = await fetch(`${APIURL}/api/reporte-usuario/periodo-encuesta-tecnologias`);
                const data = await response.json();

                setYearsTecnologia(data);
                if (data.length > 0) {
                    setYearTecnologia(data[0].anioAcademico);
                }

                MySwal.close();
            } catch (error) {
                console.error('Error al consultar los datos:', error);
                MySwal.close();
            }
        };

        fetchYears();
    }, [currentUser]);

    useEffect(() => {
        if (!yearTecnologia || !termTecnologia) {
            setCiclosTecnologia([]);
            setCicloTecnologia('');
            setTutoresTecnologia([]);
            setSelectedTutorTecnologia('');
            return;
        }

        const fetchCiclos = async () => {
            MySwal.fire({
                title: 'Cargando ciclos...',
                allowOutsideClick: false,
                didOpen: () => { MySwal.showLoading(); }
            });
            try {
                const response = await fetch(`${APIURL}/api/reporte-usuario/get-ciclos-tecnologias?anio=${yearTecnologia}&termino=${termTecnologia}`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                setCiclosTecnologia(data);
                setCicloTecnologia('');
                setTutoresTecnologia([]);
                setSelectedTutorTecnologia('');
                MySwal.close();
            } catch (error) {
                console.error('Error al consultar los ciclos:', error);
                MySwal.fire('Error', 'No se pudieron cargar los ciclos.', 'error');
            }
        };

        fetchCiclos();
    }, [yearTecnologia, termTecnologia]);

    useEffect(() => {

        if (!yearTecnologia || !termTecnologia || !cicloTecnologia) {
            setTutoresTecnologia([]);
            setSelectedTutorTecnologia('');
            return;
        }

        const fetchTutores = async () => {
            setLoadingTutores(true);
            MySwal.fire({
                title: 'Cargando tutores...',
                allowOutsideClick: false,
                didOpen: () => { MySwal.showLoading(); }
            });
            try {
                const response = await fetch(`${APIURL}/api/reporte-usuario/get-tutores-tecnologias?anio=${yearTecnologia}&termino=${termTecnologia}&ciclo=${cicloTecnologia}`);
                if (!response.ok) throw new Error('Network response was not ok');
                const data = await response.json();
                setTutoresTecnologia(data);
                setSelectedTutorTecnologia('')
                MySwal.close();
            } catch (error) {
                console.error('Error al consultar los tutores:', error);
                MySwal.fire('Error', 'No se pudieron cargar los tutores.', 'error');
            } finally {
                setLoadingTutores(false);
                if (MySwal.isVisible()) {
                    MySwal.close();
                }
            }
        };

        fetchTutores();
    }, [yearTecnologia, termTecnologia, cicloTecnologia]);


    const handleYearTecnologiaChange = (e) => {
        const newYear = e.target.value;
        setYearTecnologia(newYear);
        setTermTecnologia('');
        setCicloTecnologia('');
        setSelectedTutorTecnologia('');
        setCiclosTecnologia([]);
        setTutoresTecnologia([]);
    };

    const handleTermTecnologiaChange = (e) => {
        const newTerm = e.target.value;
        setTermTecnologia(newTerm);
        setCicloTecnologia('');
        setSelectedTutorTecnologia('');
        setTutoresTecnologia([]);
    };

    const handleCicloTecnologiaChange = (e) => {
        const newCiclo = e.target.value;
        setCicloTecnologia(newCiclo);
        setSelectedTutorTecnologia('');
    };

    const handleTutorTecnologiaChange = (e) => {
        setSelectedTutorTecnologia(e.target.value);
    };

    const downloadReportTecnologia = async (tipoEncuesta) => {
        let url = '';
        let requiredValues = {};
        setPdfData(null);
        setPdfLoadingError(null);

        if (tipoEncuesta === 'tutores') {
            if (!yearTecnologia || !termTecnologia || !cicloTecnologia || !selectedTutorTecnologia) {
                MySwal.fire('Error', 'Debe seleccionar Año, Término, Ciclo y Tutor para generar el reporte por tutor.', 'error');
                return;
            }
            requiredValues = { yearTecnologia, termTecnologia, cicloTecnologia, selectedTutorTecnologia };
            url = `${APIURL}/api/reporte-usuario/reporte-tutor-tecn/${requiredValues.yearTecnologia}/${requiredValues.termTecnologia}/${requiredValues.cicloTecnologia}/${requiredValues.selectedTutorTecnologia}`;
        } else if (tipoEncuesta === 'servicios') {
            if (!yearTecnologia || !termTecnologia || !cicloTecnologia) {
                MySwal.fire('Error', 'Debe seleccionar Año, Término y Ciclo para generar el reporte de servicios.', 'error');
                return;
            }
            if (selectedTutorTecnologia) {
                MySwal.fire('Error', 'Deseleccione el Tutor para generar el reporte de servicios por ciclo.', 'warning');
                return;
            }
            requiredValues = { yearTecnologia, termTecnologia, cicloTecnologia };
            url = `${APIURL}/api/reporte-usuario/reporte-servicios-tecn/${requiredValues.yearTecnologia}/${requiredValues.termTecnologia}/${requiredValues.cicloTecnologia}`;
        } else {
            console.error("Tipo de encuesta desconocido:", tipoEncuesta);
            MySwal.fire('Error', 'Tipo de reporte no reconocido.', 'error');
            return;
        }

        try {
            MySwal.fire({
                title: `Generando PDF (${tipoEncuesta})...`,
                text: 'Espere un momento',
                allowOutsideClick: false,
                didOpen: () => {
                    MySwal.showLoading();
                }
            });

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                }
            });

            if (!response.ok) {
                let errorMsg = `Error ${response.status}: ${response.statusText}`;
                try {
                    const errorData = await response.json();
                    errorMsg = errorData.message || errorData.title || errorMsg;
                } catch (e) {
                    throw new Error(errorMsg);
                }                
            }

            const data = await response.json();

            if (data && data.result) {
                setPdfData(data.result);
                MySwal.close();
                MySwal.fire({
                    title: 'PDF Generado',
                    text: 'El PDF está listo para visualizarse.',
                    icon: 'success',
                    timer: 1500,
                    showConfirmButton: false
                });

            } else {
                console.error("Respuesta JSON inválida o falta el campo 'result':", data);
                throw new Error("La respuesta del servidor no contiene los datos del PDF esperados.");
            }

        } catch (error) {
            console.error("Error al generar/recuperar el PDF:", error);
            setPdfLoadingError(error.message || 'No se pudo generar el PDF.');
            setPdfData(null);
            if (MySwal.isVisible()) {
                MySwal.close();
            }
            MySwal.fire('Error', `No se pudo generar el PDF: ${error.message || 'Error desconocido'}`, 'error');
        }
    };

    return (
        <>
            <h1 id="pageHeader">Reportes tecnolog&iacute;as</h1>
            <div style={{ display: "flex", flexDirection: "column", gap: "2rem" }}>
                {currentUser && currentUser.usuario && currentUser.roles
                    && (currentUser.roles.some(r => r.role === "ADMIN" || r.role === "COORDINADOR_TECN")) &&
                    <Card>
                        <CardHeader>TECNOLOGÍAS</CardHeader>
                        <CardBody>
                            <Row form>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="yearSelectTecnologia">Año</Label>
                                        <Input
                                            type="select"
                                            name="yearTecnologia"
                                            id="yearSelectTecnologia"
                                            value={yearTecnologia}
                                            onChange={handleYearTecnologiaChange}
                                            disabled={yearsTecnologia.length === 0}
                                        >
                                            <option value="">Seleccionar año</option>
                                            {yearsTecnologia.map((y, index) => (
                                                <option key={index} value={y.anioAcademico}>{y.anioAcademico}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="termSelectTecnologia">Término</Label>
                                        <Input
                                            type="select"
                                            name="termTecnologia"
                                            id="termSelectTecnologia"
                                            value={termTecnologia}
                                            onChange={handleTermTecnologiaChange}
                                            disabled={!yearTecnologia}
                                        >
                                            <option value="">Seleccionar término</option>
                                            <option value="1S">1S</option>
                                            <option value="2S">2S</option>
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="cicloSelectTecnologia">Ciclo</Label>
                                        <Input
                                            type="select"
                                            name="cicloTecnologia"
                                            id="cicloSelectTecnologia"
                                            value={cicloTecnologia}
                                            onChange={handleCicloTecnologiaChange}
                                            disabled={!termTecnologia || ciclosTecnologia.length === 0}
                                        >
                                            <option value="">Seleccionar ciclo</option>
                                            {ciclosTecnologia.map((ciclo, index) => (
                                                <option key={index} value={ciclo.value}>{ciclo.value}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                                <Col md={3}>
                                    <FormGroup>
                                        <Label for="tutorSelectTecnologia">Tutor</Label>
                                        <Input
                                            type="select"
                                            name="tutorTecnologia"
                                            id="tutorSelectTecnologia"
                                            value={selectedTutorTecnologia}
                                            onChange={handleTutorTecnologiaChange}
                                            disabled={!cicloTecnologia || loadingTutores || tutoresTecnologia.length === 0}
                                        >
                                            <option value="">{loadingTutores ? 'Cargando...' : 'Seleccionar tutor'}</option>
                                            {tutoresTecnologia.map((tutor) => (
                                                <option key={tutor.value} value={tutor.value}>{tutor.label}</option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <div style={{ display: "flex", gap: "1rem", marginTop: "1rem" }}>
                                        <Button
                                            color="success"
                                            onClick={() => downloadReportTecnologia('tutores')}
                                            disabled={!yearTecnologia || !termTecnologia || !cicloTecnologia || !selectedTutorTecnologia}
                                            title={!selectedTutorTecnologia ? "Seleccione un tutor para habilitar este reporte" : "Generar reporte por tutor"}
                                        >
                                            <FaFileExcel /> Reporte por Tutor
                                        </Button>
                                        <Button
                                            color="info"
                                            onClick={() => downloadReportTecnologia('servicios')}
                                            disabled={!yearTecnologia || !termTecnologia || !cicloTecnologia || !!selectedTutorTecnologia}
                                            title={!!selectedTutorTecnologia ? "Deseleccione el tutor para habilitar este reporte" : "Generar reporte de servicios"}
                                        >
                                            <FaFileExcel /> Reporte Servicios (Ciclo)
                                        </Button>
                                    </div>
                                </Col>
                            </Row>
                            {pdfLoadingError && (
                                <Row className="mt-3">
                                    <Col>
                                        <Alert color="danger">
                                            Error al cargar PDF: {pdfLoadingError}
                                        </Alert>
                                    </Col>
                                </Row>
                            )}
                            {pdfData && !pdfLoadingError && (
                                <Row className="mt-3">
                                    <Col>
                                        <Button
                                            color="secondary"
                                            onClick={() => {
                                                const pdfWindow = window.open("");
                                                pdfWindow.document.write(
                                                    `<iframe width='100%' height='100%' src='data:application/pdf;base64,${pdfData}'></iframe>`
                                                );
                                                pdfWindow.document.title = "Vista Previa PDF";
                                            }}
                                        >
                                            Ver PDF Generado
                                        </Button>
                                        <small className="ml-2 text-muted">(Se abrirá en una nueva pestaña)</small>
                                    </Col>
                                </Row>
                            )}
                        </CardBody>
                    </Card>
                }
            </div>
        </>
    );
};

export default withRoleAccess(ReportesTecnologias, ["ADMIN", "COORDINADOR_TECN"]);